import { Component, OnInit, Input, Injector, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentServiceTokens } from '../../app.module';
import { IPayment } from '../../interfaces/ipayment';
import { DatastoreService } from '../../services';
import { ApiService } from '../../services';
import { CommonFunctionsService } from '../../services';
import { lineOutstanding } from '../../services';
import { PaymentStartService } from '../../services';


@Component({
	selector: 'app-payment-amount',
	templateUrl: './payment-amount.component.html',
	styleUrls: ['./payment-amount.component.scss'],
})
export class PaymentAmountComponent implements OnInit, OnChanges {
	amountForm: FormGroup;
	amountDisabled = false;
	paymentService: IPayment;
	@Input() paymentType: string;
	@Input() action: string;
	@Input() amount: any;
	@Input() outstanding: any;
	@Input() booking: any;
	@Input() service: any;
	@Input() bookingLinks: any[];
	@Input() showClose: boolean;
	@Input() extraItems: undefined | any[] = undefined;

	extraItem: any = false;
	extraCount: number[] = [...Array(30).keys()].map((i) => i + 1);
	revCodeError: boolean = false;
	/** The payment_started stamp failed — the payment was not started. */
	paymentStartError = false;

	constructor(
		private injector: Injector,
		private dataStore: DatastoreService,
		private apiService: ApiService,
		private commonFunctionsService: CommonFunctionsService,
		private paymentStart: PaymentStartService
	) {}

	get communicationLink(): any[] {
		return [
			'/',
			this.commonFunctionsService.getCompanyName(),
			this.commonFunctionsService.getCompanyId(),
			'communication',
		];
	}

	private scrollToPaymentStartError(): void {
		setTimeout(() => {
			document
				.querySelector('[data-test="payment-amount-start-error"]')
				?.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}, 0);
	}

	/**
	 * Full page load, not a router navigation: the likeliest stamp-failure cause
	 * is an expired session, and only a document load re-runs the auth flow and
	 * gets a fresh token.
	 */
	restart(): void {
		window.location.assign(
			`/${this.commonFunctionsService.getCompanyName()}/${this.commonFunctionsService.getCompanyId()}/our-ceremony`,
		);
	}

	private scrollToRevCodeError(): void {
		setTimeout(() => {
			document
				.querySelector('[data-test="payment-amount-rev-code-error"]')
				?.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}, 0);
	}

	get form() {
		if (this.amountForm) {
			return this.amountForm?.controls;
		}
	}

	ngOnInit(): void {
		// set up payment type
		this.setupPaymentType();
	}

	setupPaymentType() {
		let serviceToUse = 'capita';
		if (null !== this.paymentService) {
			serviceToUse = this.paymentType;
		}
		const t: any = PaymentServiceTokens.get(serviceToUse);
		console.log('token', t);
		this.paymentService = this.injector.get(t);
    console.log('this.paymentService', this.paymentService);

		this.buildForm();
	}

	ngOnChanges(changes: SimpleChanges): void {
		console.log(changes);
		this.setupPaymentType();
	}

	async buildForm() {
		console.log('building amount form');
		console.log('action', this.action);
		this.amountForm = new FormGroup({});
		let initialAmount = 0;

		if (this.action === 'installments') {
			initialAmount = 50;
		}

		if (this.action === 'balance') {
			initialAmount = this.amount;
			console.log(this.amount);
			if (initialAmount < 0) {
				initialAmount = 0;
			}
			this.amountDisabled = true;
		} else {
			this.amountDisabled = false;
		}
		const amountControl = new FormControl(initialAmount, [Validators.required]);

		this.amountForm.addControl('amount', amountControl);

		console.log(`Amount disabled: ${this.amountDisabled}`);
		this.amountForm.valueChanges.subscribe((values) => {
			if (this.action === 'extra_items') {
				let amount = 0;
				let formattedNumber;
				for (const extra of Object.keys(values.extraItems)) {
					const extraItem = this.extraItems.find(
						(e: any) => e.item_id === extra
					);
					if (extraItem) {
						amount += extraItem.item_price * values.extraItems[extra];
						// const amountFormatter = new Intl.NumberFormat('en-GB', {
						//   style: 'currency',
						//   currency: 'GBP'
						// });
						// amountDisplay = amountFormatter.format(amount);
						const formatter = new Intl.NumberFormat('en-GB', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						});

						formattedNumber = formatter.format(amount);
					}
				}
				this.amountForm.controls['amount'].setValue(formattedNumber, {
					onlySelf: true,
				});
			}
		});
	}

	async submit() {
		localStorage.removeItem('paymentAction');
		localStorage.setItem('paymentAction', this.action);
		this.revCodeError = false;
		if (this.action === 'installments' || this.action == 'balance') {
			if (this.amountForm.controls['amount'].value > this.outstanding) {
				this.amountForm.controls['amount'].setErrors({ amountTooHigh: true });
			}
		}
		if (this.action == 'installments') {
			if (this.amountForm.controls['amount'].value < 50) {
				this.amountForm.controls['amount'].setErrors({ amountTooLow: true });
			}
		}

		if (this.amountForm.valid) {
			let service = this.dataStore.selectedService;
			if (!service) {
				const serviceStr = localStorage.getItem('service') as string;
				service = JSON.parse(serviceStr);
			}
			if (this.action !== 'extra_items') {
				if (service.hasOwnProperty('extra')) {
					if (service.extra.hasOwnProperty('fees_extra_item_id')) {
						this.extraItem = (await this.apiService.getServiceItemExtra(
							this.booking.company_id,
							service.extra.fees_extra_item_id,
							service.global_id
						)) as any;
					}
				}
			}

			try {
				if (this.action === 'extra_items') {
					if (this.extraItem) {
						localStorage.setItem('extraItem', JSON.stringify(this.extraItem));
						for (const link of this.bookingLinks) {
							console.log(link);
							if (link.item_id === this.extraItem.item_id) {
								// need to increase the qty and price
								const extraItemsGrp = this.amountForm.get(
									'extraItems'
								) as FormGroup;
								console.log(extraItemsGrp);
								const qty = parseInt(extraItemsGrp.value[link.item_id]);
								const existingQty = parseInt(link.data.quantity);
								link.data.quantity = `${qty}`;
								localStorage.setItem('extraItemLink', JSON.stringify(link));
								break;
							}
						}
					}
				}
        console.log('extraItem', this.extraItem);

				// Per-line model: charge each line's unpaid remainder. The
				// bookingLinks arrive reconciled from payment-information
				// (legacy bookings carry the payment-history attribution), so
				// no deposit special-casing is needed here. Persist every link
				// so payment-verify settles the whole booking after payment.
				const balanceFeeItems = this.action === 'balance'
					? this.bookingLinks.filter(l => lineOutstanding(l.data) > 0)
					: undefined;

				if (this.action === 'balance') {
					if (balanceFeeItems.length > 0) {
						localStorage.setItem('paidLinks', JSON.stringify(this.bookingLinks));
					} else {
						localStorage.removeItem('paidLinks');
					}
				}

				if (this.paymentService.paymentType === 'heycentric') {
					const hasNullRev = this.action === 'balance'
						? balanceFeeItems.some(f => !f.pmtTyp)
						: !this.extraItem?.data?.pmtTyp;
					if (hasNullRev) {
						console.error('Blocking payment: null Rev code at invoke for action', this.action);
						this.revCodeError = true;
						this.scrollToRevCodeError();
						return;
					}
				}

				const init: any = await this.paymentService.invoke(
					this.booking.company_id,
					this.booking.id,
					this.booking.purchase_id,
					this.dataStore.member.id,
					this.extraItem.item_description,
					this.extraItem.data?.pmtTyp,
					null,
					this.amountForm.controls['amount'].value * 100,
					false,
					balanceFeeItems
				);

        let needsSCPCheck = false;
        if (this.paymentService.paymentType === 'capita') {
          needsSCPCheck = true;
        }

        let hasSCP = true;
        if (needsSCPCheck) {
          hasSCP = init.scp;
        }
        console.log('init', init);

				if (init.url && hasSCP) {
          if (needsSCPCheck) {
            localStorage.setItem('paymentId', init.scp);
          }
          // A failed stamp must ABORT before the gateway: verify treats a
          // missing stamp as a failed payment (see booking 11271).
          const stamped = await this.paymentStart.stampPaymentStarted(this.booking);
          if (!stamped) {
            localStorage.removeItem('paidLinks');
            localStorage.removeItem('paymentAction');
            this.paymentStartError = true;
            this.scrollToPaymentStartError();
            return;
          }
          this.booking = stamped;
					window.location.href = init.url;
				} else {
					console.error('NO URL RETURNED FROM PAYMENT PROVIDER', `Provider: ${this.paymentService.paymentType}`);
				}
			} catch (err) {
				console.error(`Problem invoking payment method`);
				console.error(err);
			}
		}
	}

}
